import { defineComponent as _defineComponent } from 'vue'
import { CourseSection } from '@/entities/trainings';
  import { storeToRefs } from 'pinia';
  import { useCourseTakeStore } from '@/stores/trainings/courseTake';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'Section',
  props: {
    item: {
      type: Object as () => CourseSection,
      required: true,
    },
  },
  setup(__props) {

  

  const { activeSectionIndex, sectionsCount } = storeToRefs(useCourseTakeStore());

return { __sfc: true,activeSectionIndex, sectionsCount }
}

})